export default "__VITE_ASSET__6364e945__"